var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.collapse)?_c('el-collapse',{attrs:{"accordion":""}},[_c('el-collapse-item',{attrs:{"name":"1"}},[_c('template',{slot:"title"},[_vm._v(" Instructions ")]),_c(_vm.instruction,{tag:"component"})],2)],1):_c(_vm.instruction,{tag:"component"})}
var staticRenderFns = []

export { render, staticRenderFns }